import React, { useEffect } from 'react';
import AmountDisplay from '../AmountDisplay';
import DonationsCard from './DonationsCard';
import DonationDetails from './DonationDetails';
import { CheckoutWizardProps } from '../CheckoutWizardInterfaces';
import { usePushEvents } from '../../../../../hooks/PushEvents';
import {
    addDonationOnGiftSummary,
    giftSummaryScreen,
} from '../../../../../hooks/PushEvents/clevertapEvents';
import OpacityAnimation from '../../../../Animations/OpacityAnimation';
import { useDonorContext } from '../../../../../providers/DonorProvider/DonorProvider';
import { removeQueryString } from '../../../../../hooks/useQueryString';
import { getTotalCartAmount } from '../../../../../utils';
import { FeatureFlag } from '../../../../../constants';
import { useFeatureFlag } from '../../../../../providers';
import { useDonee, useDonorProfile } from '../../../../../api';

type CartWizardProps = Omit<CheckoutWizardProps, 'donee'>;

const CartWizard: React.FC<CartWizardProps> = ({
    cart,
    setMessage,
    setRecurring,
    removeFromCart,
    setRoute,
}) => {
    const { donorProfile } = useDonorProfile();
    const { donor, wallets } = donorProfile || {};
    const { donee } = useDonee();
    const { pushEvent } = usePushEvents();
    const { loadDonor } = useDonorContext();
    const { amount, envelopes } = getTotalCartAmount(cart.envelopes);
    const { isFeatureEnabled } = useFeatureFlag();

    const handleAddDonation = () => {
        amount &&
            pushEvent(addDonationOnGiftSummary, {
                loggedIn: Boolean(donor),
                doneeId: donee?.idShort,
                amount,
                paymentPresent: wallets?.length ? 'Yes' : 'No',
                envelopeCount: envelopes.length,
                envelope:
                    envelopes.length === 0
                        ? 'No Envelopes'
                        : envelopes.length === 1
                          ? envelopes[0].name
                          : 'Multiple',
            });
        setRoute('amount');
    };

    useEffect(
        () => {
            removeQueryString('amount');
            removeQueryString('details');
            // make sure user info is up to date
            loadDonor();
            pushEvent(giftSummaryScreen, {
                loggedIn: Boolean(donor),
                doneeId: donee?.idShort,
                amount,
                envelopeCount: envelopes.length,
                paymentPresent: wallets && wallets.length > 0 ? 'Yes' : 'No',
                envelope:
                    envelopes.length === 1 ? envelopes[0].name : 'Multiple',
                'oga-appfooterdeeplinks': isFeatureEnabled(
                    FeatureFlag.OGA_APPFOOTERDEEPLINKS,
                ),
            });
        },
        //run only once when component is mounted
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [],
    );

    if (amount === 0) {
        handleAddDonation();
        return null;
    }

    return (
        <OpacityAnimation>
            <AmountDisplay
                amount={amount}
                amountText={'Gift Summary'}
            />
            <DonationsCard
                donations={envelopes}
                handleAddDonation={handleAddDonation}
                removeEnvelope={removeFromCart}
            />
            <DonationDetails
                setRoute={setRoute}
                message={cart.message || ''}
                setMessage={setMessage}
                recurring={cart.recurring}
                setRecurring={setRecurring}
            />
        </OpacityAnimation>
    );
};

export default CartWizard;
